// extracted by mini-css-extract-plugin
module.exports = {"Disabled":"PaymentButtons_Disabled__12XRN","PaymentModal":"PaymentButtons_PaymentModal__3pnFm","PaymentButtons":"PaymentButtons_PaymentButtons__2q0pX"};